import { MonitoringOverallStatus } from '../../../../../types/DeployerControlMonitoring.types';

const statusStyles: Record<MonitoringOverallStatus, { textColor: string; bgColor: string; label: string }> = {
  STRONG: { textColor: '#027A69', bgColor: '#D0FBEB', label: 'Strong' },
  ADEQUATE: { textColor: '#B45309', bgColor: '#FEF3C7', label: 'Adequate' },
  AT_RISK: { textColor: '#C2410C', bgColor: '#FFEDD5', label: 'At Risk' },
  CRITICAL: { textColor: '#BE123C', bgColor: '#FFE4E6', label: 'Critical' }
};

interface SessionScorePillProps {
  overallStatus: MonitoringOverallStatus | null;
  overallScorePercent: number | null;
}

export function SessionScorePill({ overallStatus, overallScorePercent }: SessionScorePillProps) {
  if (!overallStatus || overallScorePercent === null) {
    return null;
  }

  const styles = statusStyles[overallStatus];

  return (
    <div className="flex items-center gap-2">
      <div
        className="w-min px-3 py-0.5 rounded-xl text-xs leading-4 font-medium text-nowrap"
        style={{ color: styles.textColor, backgroundColor: styles.bgColor }}
      >
        {styles.label}
      </div>
      <span className="text-sm text-gray-700 font-medium">{overallScorePercent}%</span>
    </div>
  );
}
